import { Phone, Mail, MapPin } from "lucide-react";
import { Seo } from "../lib/seo";
import { MaskText, Reveal } from "../lib/motion";
import { QuoteForm } from "../components/QuoteForm";
import { CONTACT } from "../data/site";

export default function Kontakt() {
  return (
    <>
      <Seo
        title="Kontakt & offert · Casagon Bygg & Allservice"
        description="Kontakta Casagon för golvläggning, bygg och renovering i hela Skåne och hela Göteborg. Ring 073-413 87 28 eller skicka en offertförfrågan."
        path="/kontakt"
      />

      <section className="grain relative overflow-hidden bg-graphite pb-24 pt-32 text-warmwhite md:pt-44" data-testid="kontakt-page">
        <div className="u-container relative z-10 grid grid-cols-1 gap-16 lg:grid-cols-12 lg:gap-20">
          {/* Left */}
          <div className="lg:col-span-5">
            <Reveal>
              <p className="overline text-casared">
                <span className="mr-2 inline-block h-2 w-2 bg-casared align-middle" />
                Kontakt & offert
              </p>
            </Reveal>
            <MaskText
              as="h1"
              animateOnLoad
              delay={0.15}
              lines={["Låt oss bygga", "något bra."]}
              className="mt-6 font-display font-bold leading-[0.95] tracking-tight text-[8vw] sm:text-6xl lg:text-7xl"
            />
            <Reveal delay={0.3}>
              <p className="mt-8 max-w-md text-base leading-relaxed text-warmwhite/70">
                Berätta vad du behöver hjälp med och var projektet finns så återkommer vi. Casagon
                utgår från Höör och tar uppdrag i hela Skåne och hela Göteborg.
              </p>
            </Reveal>

            <div className="mt-12 space-y-px">
              <a href={CONTACT.phoneHref} data-testid="kontakt-phone" className="group hairline flex items-center gap-5 py-6">
                <Phone size={20} className="text-wood" />
                <div>
                  <p className="overline text-warmwhite/40">Telefon</p>
                  <p className="font-display text-xl font-bold tracking-tight group-hover:text-wood">{CONTACT.phoneDisplay}</p>
                </div>
              </a>
              <a href={`mailto:${CONTACT.email}`} data-testid="kontakt-email" className="group hairline flex items-center gap-5 py-6">
                <Mail size={20} className="text-wood" />
                <div>
                  <p className="overline text-warmwhite/40">E-post</p>
                  <p className="font-display text-xl font-bold tracking-tight group-hover:text-wood">{CONTACT.email}</p>
                </div>
              </a>
              <div className="hairline flex items-center gap-5 py-6">
                <MapPin size={20} className="text-wood" />
                <div>
                  <p className="overline text-warmwhite/40">Utgår från</p>
                  <p className="font-display text-xl font-bold tracking-tight">{CONTACT.city}</p>
                </div>
              </div>
              <div className="hairline flex items-center gap-5 py-6">
                <MapPin size={20} className="text-wood" />
                <div>
                  <p className="overline text-warmwhite/40">Arbetsområde</p>
                  <p className="font-display text-xl font-bold tracking-tight">{CONTACT.serviceArea}</p>
                </div>
              </div>
              <div className="hairline" />
            </div>
          </div>

          {/* Right form */}
          <div className="lg:col-span-6 lg:col-start-7">
            <Reveal>
              <div className="border border-warmwhite/12 bg-surface/40 p-6 md:p-10">
                <h2 className="font-display text-2xl font-bold tracking-tight">Skicka en offertförfrågan</h2>
                <p className="mt-2 text-sm text-warmwhite/50">Fyll i så mycket du kan – det hjälper oss att ge ett träffsäkert svar.</p>
                <div className="mt-8">
                  <QuoteForm dark />
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
}
